<template>
  <div>
    <!--        <breadcrumb :routerList="[{to:'/yonghu/bscCustomer',title:'用户管理'},{title:'潜在客户'}]"/>-->
    <Breadtabsheader />
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="区域名称">
                <brselect category="YlSalesArea_chanpin" :v="q.areaCode" v-model="q.areaCode" :clearable="true" />
              </el-form-item>
              <el-form-item>
              </el-form-item>
              <el-form-item>
              </el-form-item>
              <el-form-item class="right-btn">
                <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="addRegionalFees">新增
                </el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>

      </div>
      <div class="h-row">
        <div class="h-rowIn" style="width:100%;">
          <el-table ref="multipleTable" :data="tableData" stripe :border="true" style="width: 100%" max-height="450">
            <el-table-column type="index" width="40" label="#">
            </el-table-column>
            <el-table-column prop="areaName" label="区域名称" min-width="100" :show-overflow-tooltip="true">
            </el-table-column>
            <!-- <el-table-column prop="areaCode" :show-overflow-tooltip="true" label="区域">
              <template slot-scope="scope">
                {{scope.row.areaCode | dictname('YLRegion')}}
              </template>
            </el-table-column> -->
            <el-table-column prop="rengongchengben" min-width="80" :show-overflow-tooltip="true" label="人工成本(%)">

            </el-table-column>
            <el-table-column prop="zuzhiyunyingfei" min-width="80" :show-overflow-tooltip="true" label="组织运营费(%)">

            </el-table-column>
            <el-table-column prop="yingxiaofei" min-width="80" :show-overflow-tooltip="true" label="营销费用(%)">

            </el-table-column>
            <el-table-column prop="wuliufei" min-width="80" :show-overflow-tooltip="true" label="物流费用(%)">

            </el-table-column>
            <el-table-column prop="shouhoufei" min-width="80" :show-overflow-tooltip="true" label="售后费用(%)">

            </el-table-column>
            <el-table-column prop="shuifei" min-width="80" :show-overflow-tooltip="true" label="税费(%)">

            </el-table-column>
            <el-table-column prop="zichanjianzhisunshi" min-width="80" :show-overflow-tooltip="true" label="资产减值损失(%)">
              <!-- <template slot-scope="scope">
                <el-input v-model="q.areaName" v-if="scope.row.check" size="mini"></el-input>
                <span v-else>{{scope.row.rengongchengben}}</span>
              </template> -->
            </el-table-column>
            <el-table-column label="操作" min-width="60">
              <template slot-scope="scope">
                <el-button type="text" size="small" class="h-tableLink h-btn" @click="handleEdit(scope.row)">
                  修改
                </el-button>
                <!-- <el-button type="text" size="small" class="h-tableLink h-btn" @click="handleSave(scope.row)">
                  保存
                </el-button> -->
              </template>
            </el-table-column>
          </el-table>
          <div class="h-tableB h-mrt30">
            <div class="h-tableBL">
              <!-- <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出
              </el-button> -->
              <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="uploaddownexcelflagbtn">批量导入
              </el-button>
              <!-- <el-button class="h-btn h-formBtn" @click="uploaddownexcelflagbtn">导入Excel</el-button> -->
              <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag" clsname="rateSunyicaozuobiaoAreaImportExcel" :startrow="1" @callback="uploadExcelFilecallback" />
            </div>
            <div class="h-pagination2">
              <pagination :page="q" @query="query" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2 yonghu" @close="cancel('f')" width="48%">
      <div class="h-dialogImg" style="background-size: 100%;">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>{{saveorupdate?'修改区域费用':'新增区域费用'}}</h1>
            <!-- <p>New Agent</p> -->
          </div>
        </div>
      </div>
      <div class="h-formLine h-mrb-38">
        <el-form :model="f" :rules="rules" ref="f" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
          <el-form-item label="区域" class="h-elformWrap-2" prop="areaCode">
            <brselect category="YlSalesArea_chanpin" :disabled="saveorupdate" :v="f.areaCode" v-model="f.areaCode" :clearable="true" @change="getAreaName($event)" />
          </el-form-item>
          <el-form-item label="人工成本(%)" class="h-elformWrap-2" prop="rengongchengben">
            <el-input v-model.trim="f.rengongchengben" placeholder="请输入" @input="requiredDurationEvent($event,'rengongchengben')" />
          </el-form-item>
          <el-form-item label="组织运营费(%)" class="h-elformWrap-2" prop="zuzhiyunyingfei">
            <el-input v-model.trim="f.zuzhiyunyingfei" placeholder="请输入" @input="requiredDurationEvent($event,'zuzhiyunyingfei')" />
          </el-form-item>
          <el-form-item label="营销费用(%)" class="h-elformWrap-2" prop="yingxiaofei">
            <el-input v-model.trim="f.yingxiaofei" placeholder="请输入" @input="requiredDurationEvent($event,'yingxiaofei')" />
          </el-form-item>
          <el-form-item label="物流费用(%)" class="h-elformWrap-2" prop="wuliufei">
            <el-input v-model.trim="f.wuliufei" placeholder="请输入" @input="requiredDurationEvent($event,'wuliufei')" />
          </el-form-item>
          <el-form-item label="售后费用(%)" class="h-elformWrap-2" prop="shouhoufei">
            <el-input v-model.trim="f.shouhoufei" placeholder="请输入" @input="requiredDurationEvent($event,'shouhoufei')" />
          </el-form-item>
          <el-form-item label="税费(%)" class="h-elformWrap-2" prop="shuifei">
            <el-input v-model.trim="f.shuifei" placeholder="请输入" @input="requiredDurationEvent($event,'shuifei')" />
          </el-form-item>
          <el-form-item label="资产减值损失(%)" class="h-elformWrap-2" prop="zichanjianzhisunshi">
            <el-input v-model.trim="f.zichanjianzhisunshi" placeholder="请输入" @input="requiredDurationEvent($event,'zichanjianzhisunshi')" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel('f')">取消</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ2" @click="bindInsert">提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ss from '@/api/SystemService'
import updownfile from '@/utils/updownfile'
import uploaddownexcel from '@/components/uploaddown/uploaddownexcel'
import big from 'big.js'
export default {
  components: {
    uploaddownexcel,
  },
  data () {
    return {
      //导入Excel
      uploaddownexcelflag: false,
      //分页/检索
      q: {
        areaCode: '',
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      f: {
        areaName: '',
        areaCode: '',
        rengongchengben: '',
        zuzhiyunyingfei: '',
        yingxiaofei: '',
        wuliufei: '',
        shouhoufei: '',
        shuifei: '',
        zichanjianzhisunshi: '',
      },
      rules: {
        areaCode: [{ required: true, message: '请选择区域', trigger: 'blur' }],
        rengongchengben: [{ required: true, message: '请输入人工成本', trigger: 'blur' }],
        zuzhiyunyingfei: [{ required: true, message: '请输入组织运营费', trigger: 'blur' }],
        yingxiaofei: [{ required: true, message: '请输入营销费用', trigger: 'blur' }],
        wuliufei: [{ required: true, message: '请输入物流费用', trigger: 'blur' }],
        shouhoufei: [{ required: true, message: '请输入售后费用', trigger: 'blur' }],
        shuifei: [{ required: true, message: '请输入税费', trigger: 'blur' }],
        zichanjianzhisunshi: [{ required: true, message: '请输入资产减值损失', trigger: 'blur' }],
      },
      //table列表
      tableData: [],
      dialogFormVisible: false,
      saveorupdate: false,
    }
  },
  created () {
    this.query();
  },
  methods: {

    requiredDurationEvent (value, name) {
      let dat =
        ("" + value) // 第一步：转成字符串
          .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
      // 限制输入最大值为100
      if (Number(dat) > 100) {
        this.f[name] = ''
        return ''
      } else {
        this.f[name] = dat;
      }
    },
    // 获取区域名称
    getAreaName (e) {
      this.f.areaName = e.name
    },
    // 提交
    bindInsert () {
      this.$refs['f'].validate((valid) => {
        if (valid) {
          if (this.saveorupdate) {
            ss.noticeBoard.getUpdateById(this.f).then(rd => {
              this.query();
              this.$msg.msgs(rd.msg);
              this.cancel('f')
              this.dialogFormVisible = false;
            })
          } else {
            ss.noticeBoard.saveInsert(this.f).then(rd => {
              this.query();
              this.$msg.msgs(rd.msg);
              this.cancel('f')
              this.dialogFormVisible = false;
            })
          }
        } else {
          this.$msg.msge("请完善信息后再提交！");
          return false;
        }
      });
    },
    // 新增
    addRegionalFees () {
      this.saveorupdate = false
      this.dialogFormVisible = true
    },
    //弹框关闭
    cancel (formName) {
      this.dialogFormVisible = false;
      this.f.id = '';
      this.f.areaName = '';
      this.f.areaCode = '';
      this.f.rengongchengben = '';
      this.f.zuzhiyunyingfei = '';
      this.f.yingxiaofei = '';
      this.f.wuliufei = '';
      this.f.shouhoufei = '';
      this.f.shuifei = '';
      this.f.zichanjianzhisunshi = '';
      // this.$refs[formName].resetFields();
    },
    //导入Excel
    uploaddownexcelflagbtn () {
      this.uploaddownexcelflag = true;
    },
    uploadExcelFilecallback (rd) {
      this.query();
      this.$msg.msgs(rd.msg);
    },
    //重置检索项
    resetData () {
      this.q.areaCode = ''
      this.q.pageNo = 1
      this.query();
    },
    query () {
      ss.noticeBoard.selectPage(this.q).then(rd => {
        console.log(rd, "AA");
        this.q.total = rd.total;
        this.tableData = rd.records.map(item => {
          console.log(item)
          return {
            ...item,
            rengongchengben: item.rengongchengben ? new big(item.rengongchengben).times('100').toString() : '',
            zuzhiyunyingfei: item.zuzhiyunyingfei ? new big(item.zuzhiyunyingfei).times('100').toString() : '',
            yingxiaofei: item.yingxiaofei ? new big(item.yingxiaofei).times('100').toString() : '',
            wuliufei: item.wuliufei ? new big(item.wuliufei).times('100').toString() : '',
            shouhoufei: item.shouhoufei ? new big(item.shouhoufei).times('100').toString() : '',
            shuifei: item.shuifei ? new big(item.shuifei).times('100').toString() : '',
            zichanjianzhisunshi: item.zichanjianzhisunshi ? new big(item.zichanjianzhisunshi).times('100').toString() : '',
          }
        })
        console.log(this.tableData)
      })
    },


    //删除
    handleSave (value) {
      // this.$msg.confirm("确认删除?", () => {
      //   ss.customer.deleteById(value.id).then(rd => {
      //     this.query();
      //     this.$msg.msgs(rd.msg);
      //   });
      // });
    },
    //编辑
    handleEdit (row) {
      // console.log(row)
      this.saveorupdate = true
      this.f.id = row.id
      this.f.areaName = row.areaName;
      this.f.areaCode = row.areaCode;
      this.f.rengongchengben = row.rengongchengben
      this.f.zuzhiyunyingfei = row.zuzhiyunyingfei
      this.f.yingxiaofei = row.yingxiaofei
      this.f.wuliufei = row.wuliufei
      this.f.shouhoufei = row.shouhoufei
      this.f.shuifei = row.shuifei
      this.f.zichanjianzhisunshi = row.zichanjianzhisunshi
      this.dialogFormVisible = true;
    },
    //批量导出
    exportExcel () {
      updownfile.down("/api/swyl/v1/yonghu/bscCustomer/downloadExcelBscCustomer", this.q, "post", 'data');
    },
  }
}
</script>

<style>
.yonghu .h-formbLine .h-elformWrap-2 {
  width: 50%;
}

.yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__label {
  width: 41%;
}

.yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__content {
  width: 59%;
}

.yonghu .h-formbLine .el-form-item__content .el-select {
  width: 100% !important;
}

.h-dialog3.dialogFormVisible3 .el-dialog__body {
  padding: 0 0.5rem 0.3rem 0.5rem;
}

.h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
  width: 100%;
  height: 103px;
  border: 1px dashed #7c9ec0;
  background: 0;
  line-height: 103px;
  margin-top: 20px;
  color: #4b4b4b;
  font-size: 18px;
}
</style>
